import { syncService } from './syncService';
import { userService } from './userService';
import { useLoaderData, useNavigate, useOutletContext, useSubmit, useNavigate } from "react-router";
import React, { useEffect, useState } from 'react'
import { Button } from '@headlessui/react';
import { ArrowDownIcon } from '@heroicons/react/24/outline'
import versionInfo from './version.json';

export async function userLoader({ }) {
  let session = await userService.getSession();
  let res = await (await fetch(`/data/version.json`)).json();
  return { session, res };
}

let aAccount = {};
let navigate = {};
let msalInstance = {};
export function User({ }) {
  navigate = useNavigate();
  const { activeAccount, instance } = useOutletContext();
  const { session, res } = useLoaderData();
  const [ salesUser, setSalesUser] = useState(false);
  let submit = useSubmit();
  
  useEffect(() => {
    aAccount = activeAccount;
    msalInstance = instance;

    const fetchData = async () => {
      let test = await isSalesUser(aAccount);
      console.log(`isSales: ${test}`)
      setSalesUser(test);
    };
    fetchData();
    
  }, []);

  return (
    <>
      <div className="h-screen min-w-full overflow-hidden bg-black font-pin relative">
        <div className="top-0 left-0 p-6">
          <img
            alt="PVS"
            src="/logo.svg"
            className="h-8"
          />
        </div>

        <div className="absolute top-0 right-0 p-6 pl-6">
          <img
            alt="Yellow"
            src="/yellow.svg"
            className=""
          />

        </div>

        {!salesUser && 
        <>
          <div className="pt-6 pt-2 pl-6 text-xl font-semibold">My Profile</div>
          <div className="pt-2 pl-6 text-6xl font-semibold">Driver</div>
          <div className="pl-6 text-6xl font-semibold">{session?.full_name}</div>

          <div className="bg-black mx-6 mt-6 mb-4 h-1/3 overflow-scroll">
            <Button onClick={() => {
              submit(
                { token: activeAccount.idToken, action: "sync" },
                { action: "/user", method: "post" }
              );
            }} className="w-full bg-pvs-gray block rounded p-3.5 items-center justify-center text-white">Sync today's orders
            </Button>
            <Button onClick={() => {
              navigate("/status")
            }}
              className="w-full bg-pvs-gray block rounded p-3.5 items-center justify-center text-white mt-2">Sync Status
            </Button>
            <Button onClick={() => {
              submit(
                { token: activeAccount.idToken, action: "logout" },
                { action: "/user", method: "post" }
              );
            }}
              className="w-full bg-pvs-gray block rounded p-3.5 items-center justify-center text-white mt-2">Logout
            </Button>
            <div className="text-sm pt-4">Client Version : {versionInfo.version}</div>
            <div className="text-sm pt-4">Server Version : {res.version}</div>

          </div>
        </>
        }


        {salesUser && 
        <>
          <div className="pt-6 pt-2 pl-6 text-xl font-semibold">My Profile</div>
          <div className="pl-6 text-6xl font-semibold">{session?.full_name}</div>

          <div className="bg-black mx-6 mt-6 mb-4 h-1/3 overflow-scroll">
            <Button onClick={() => {
              submit(
                { token: activeAccount.idToken, action: "syncSales" },
                { action: "/user", method: "post" }
              );
            }} className="w-full bg-pvs-gray block rounded p-3.5 items-center justify-center text-white">Sync</Button>
            <Button onClick={() => {
              submit(
                { token: activeAccount.idToken, action: "logoutSales" },
                { action: "/user", method: "post" }
              );
            }}
              className="w-full bg-pvs-gray block rounded p-3.5 items-center justify-center text-white mt-2">Logout
            </Button>
            <div className="text-sm pt-4">Client Version : {versionInfo.version}</div>
            <div className="text-sm pt-4">Server Version : {res.version}</div>
          </div>
        </>
        }

        <div className="bg-white absolute bottom-0 right-0 mb-4">
          <img
            alt="PVS"
            src="/truck.svg"
            className="min-w-full bg-black h-60"
          />
        </div>

        <div className="absolute -left-16 w-32 h-32 bg-pvs-gray rotate-45 rounded-lg top-2/3 ">

        </div>

        <div className="absolute w-32 h-32 top-2/3 flex items-center justify-center ">
          <ArrowDownIcon className="h-8 pr-12 bold"
            onClick={() => {
              submit(
                { token: activeAccount.idToken, action: "goToShipment" },
                { action: "/user", method: "post" }
              );
            }} ></ArrowDownIcon>
        </div>

      </div>
    </>
  );
}


export async function userActions(request) {

  let formData = await request.formData();
  let action = formData.get("action");

  console.log(`User action : ${action}`);

  if (action === "sync") {
    await syncService.syncShipments(formData.get("token"));
    navigate("/shipments")
  }

  if (action === "syncSales") {
    await syncService.resetSyncDate();
    navigate("/")
  }

  if (action === "logout") {
    console.log("logging out ")
    await userService.logout();
    navigate("/");
  }

  if (action === "logoutSales") {
    console.log("logging out ")
    if(await isSalesUser(aAccount))
    {
      userService.logout();
      msalInstance.logoutRedirect({
        postLogoutRedirectUri: "/", 
      });
      window.location.reload();
    }
    navigate("/");
  }

  if (action === "goToShipment") {
    if (await isSalesUser(aAccount)) {
      navigate("/");
    } else {
      navigate("/shipments")
    }

  }
}

async function isSalesUser(activeAccount) {
  return await userService.isSalesUser(activeAccount);
}

